const generateUUID = () => {
  let d = new Date().getTime()
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
}

const maskString = (val) => {
  if (!val) {
    return ''
  }
  const size = val.length
  return `${val.substring(0, Math.floor(size / 2))}*****`
}

const checkBrowserIsWebview = () => {
  const navigator = window.navigator
  const userAgent = navigator.userAgent
  const normalizedUserAgent = userAgent.toLowerCase()
  const standalone = navigator.standalone

  const isIos = /ip(ad|hone|od)/.test(normalizedUserAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  const isAndroid = /android/.test(normalizedUserAgent)
  const isSafari = /safari/.test(normalizedUserAgent)
  const isWebview = (isAndroid && / wv\)/.test(normalizedUserAgent)) || (isIos && !standalone && !isSafari)

  return isWebview
}

const extractGloboIdToken = (cookies) => {
  const getNewError = () => new Error('Could not find GLOBO_ID cookie in this session')    
  if (!cookies) { throw getNewError() }
      
  const globoIdJWT = cookies.split('; ').find(cookie => cookie.startsWith('GLOBO_ID'))

  if (!globoIdJWT) {
    throw getNewError()
  }

  return globoIdJWT.split('=')[1]
}

const validateToken = async (token) => {        
  // eslint-disable-next-line no-undef
  const url = `${WEB_BFF_URL}/validate-token`
  const data = {
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
      'X-Globo-ID': token,
    },
    timeout: 5000,
  }      

  try {
    const response = await fetch(url, data)
    if (response.ok) { return await response.json() }
  } catch (error) {
    console.error('error on validate token request', error)
  }
  return null
}

function decodeJWT(token) {
  try {
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))

    return JSON.parse(jsonPayload)
  } catch (error) {
    console.error('Error decoding token:', error)
    return null
  }
}

export { maskString, generateUUID, checkBrowserIsWebview, extractGloboIdToken, validateToken, decodeJWT }